import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { AuthError, GetTokenConfig } from '@auspost/auth0-uiim-types';

import { authService } from '../store/customer/utils/auth0.util';
import { auth0EndpointConfig } from './auth0-interceptor.config';

// Intercept API calls based on configuration

export function requestInterceptor(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.request.use(
    async (config: AxiosRequestConfig) => {
      const { url, method } = config;
      if (!url || !method) return config;

      // match request urls
      const matchedConfig = auth0EndpointConfig.find((endpointConfig) => {
        if (endpointConfig.method && endpointConfig.method.toUpperCase() !== method.toUpperCase()) return;
        return url.includes(endpointConfig.endpoint);
      });

      if (!matchedConfig) return config;

      const { audience, scope, allowAnon } = matchedConfig;
      let accessToken;
      try {
        accessToken = await getAccessToken({ audience, scope });
      } catch (e) {
        if (allowAnon) return config;
        throw e;
      }

      if (accessToken && config.headers) {
        config.headers['Authorization'] = 'Bearer ' + accessToken;
      }

      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
}

export const getAccessToken = async (options?: GetTokenConfig) => {
  if (!authService) return null;

  try {
    return await authService.getAccessTokenSilently(options);
  } catch (error) {
    const authError = error as AuthError;
    throw authError;
  }
};
